import { Input, Component } from '@angular/core';
import { LoaderService } from '../../../infrastructure/services/loader.service';

@Component({
    selector: 'sx-loader',
    templateUrl: './loader.component.html',
})
export class LoaderComponent {
    constructor(public loaderService: LoaderService) {}
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/loader/loader.component.ts